import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HeaderUsuarioComponent } from '../../components/header-usuario/header-usuario.component';
import { FooterComponent } from '../../components/footer/footer.component';
@Component({
    selector: 'app-nao-tem-acesso',
    templateUrl: './nao-tem-acesso.component.html',
    styleUrls: ['./nao-tem-acesso.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderUsuarioComponent, FooterComponent]
})
export class NaoTemAcessoComponent {

  constructor() { }
}
